@let connected = websocketService.connectionStatus$ | async;
<ion-toast [isOpen]="!connected" message="Connecting..." color="medium" swipeGesture="vertical" position="top"></ion-toast>
<ion-router-outlet></ion-router-outlet>
